import React, {useContext, useEffect, useState, useRef} from "react";
import {Center, Grids, ContainerMelhorEnvio, ModalContainer} from "./styles";
import {Button} from "../../Button";
import LoadingComFundo from "../../Loading/LoadingComFundo/LoadingComFundo";
import SkeletonBling from "../../Skeletons/SkeletonBling/SkeletonBling";
import {useTheme} from "../../../contexts/Theme/ThemeContext";
import {EmpresaContext} from "../../../contexts/Empresa/EmpresaContext";
import {ConfiguracoesContext} from "../../../contexts/Configuracoes/ConfiguracoesContext";
import {Input} from "../../Input";
import {MelhorEnvioApi} from "../../../hooks/melhorEnvio";
import Swal from "sweetalert2";
import Modal from "../../Modal/Modal";
import {hostname, baseURL} from "../../../hooks/useApi";

const MelhorEnvio: React.FC = () => {
    const {empresa, setEmpresa} = useContext(EmpresaContext);
    const {theme} = useTheme();
    const api = MelhorEnvioApi();
    const {configuracoes, setConfiguracoes} = useContext(ConfiguracoesContext);
    const [loading, setLoading] = useState(true);
    const [modalAutorizacao, setModalAutorizacao] = useState(true);
    const nomeUsuario = empresa?.usuario;
    const [autenticado, setAutenticado] = useState(false);

    const [urlBase, setUrlBase] = useState("");
    const [urlRedirecionamento, setUrlRedirecionamento] = useState(
        "https://painel-api.conectavenda.com.br/melhor_envio/autenticacao"
    );
    const [urlMelhorEnvio, setUrlMelhorEnvio] = useState("");
    const [clientId, setClientId] = useState(14208);
    const [secret, setSecret] = useState(
        "0387SJjIYo7uNzds8Szwb22GMxMRpCzOS48gYauw"
    );

    const cancelar = () => {
        setModalAutorizacao(false);

        setConfiguracoes({
            ...configuracoes,
            frete: {
                ...configuracoes.frete,
                melhorEnvio: {
                    ...configuracoes.frete.melhorEnvio,
                    ativo: false,
                },
            },
        });
    };

    const verificarAutenticacao = async () => {
        const res = await api.verificarAutenticacao();

        if (res.error) {
            if (res.url) {
                setAutenticado(false);
            } else {
                Swal.fire({
                    title: "Erro inesperado ao verificar autenticação!",
                    text: res.error,
                    icon: "error",
                });
            }
        } else if (res.ativo) {
            setAutenticado(true);
            // Atualiza as configurações com os dados recebidos do backend
            setConfiguracoes({
                ...configuracoes,
                frete: {
                    ...configuracoes.frete,
                    melhorEnvio: {
                        ...configuracoes.frete.melhorEnvio,
                        ativo: true,
                        ...(res.token && {access_token: res.token}),
                        ...(res.altura && {altura: res.altura}),
                        ...(res.largura && {largura: res.largura}),
                        ...(res.comprimento && {comprimento: res.comprimento}),
                        ...(res.peso && {peso: res.peso}),
                        ...(res.refresh_token && {refresh_token: res.refresh_token}),
                        ...(res.token_type && {token_type: res.token_type}),
                        ...(res.expires_in && {expires_in: res.expires_in}),
                    },
                },
            });
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChangeRef.current
            );
        } else {
            setAutenticado(false);
            Swal.fire({
                title: "Erro inesperado ao verificar autenticação!",
                text: "Erro desconhecido",
                icon: "error",
            });
        }
        setLoading(false);
    };

    const handleVisibilityChange = async () => {
        if (document.visibilityState === "visible") {
            await verificarAutenticacao();
        }
    };

    const handleVisibilityChangeRef = useRef(() => {
    });

    useEffect(() => {
        setUrlRedirecionamento(`${urlBase}melhor_envio/autenticacao`);
    }, [urlBase]);

    useEffect(() => {
        handleVisibilityChangeRef.current = handleVisibilityChange;

        const init = async () => {
            handleVisibilityChangeRef.current();
        };

        init();

        if (
            hostname == "localhost"
        ) {
            setUrlBase("http://lvh.me/conecta-painel-api/api/");
            setUrlMelhorEnvio("https://sandbox.melhorenvio.com.br/");
            setClientId(7827);
            setSecret("MtQ8DMek14GY56El4pLJzerWTZwSytiip3vDaz5p");
        } else if (hostname == "painel-api-dev.conectavenda.com.br") {
            setUrlBase("https://painel-api-dev.conectavenda.com.br/");
            setUrlMelhorEnvio("https://sandbox.melhorenvio.com.br/");
            setClientId(4516);
            setSecret("ooGhzgKGJroF31JyUyRxP4Jiqj6aq3H79YEPHXXv");
        } else {
            setUrlBase(baseURL);
            setUrlMelhorEnvio("https://melhorenvio.com.br/");
        }

        document.addEventListener(
            "visibilitychange",
            handleVisibilityChangeRef.current
        );

        return () => {
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChangeRef.current
            );
        };
    }, []);

    return (
        <ContainerMelhorEnvio theme={theme}>
            {!autenticado && !loading && (
                <>
                    <Modal
                        width={"80rem"}
                        maxWidth="98vw"
                        isOpen={modalAutorizacao}
                        backdrop={"static"}
                        setModal={setModalAutorizacao}
                    >
                        <ModalContainer theme={theme}>
                            {loading ? (
                                <LoadingComFundo/>
                            ) : (
                                <>
                                    <div className="titulo fonteTitulo">Autorização Melhor Envio</div>
                                    <div className="texto fonteTexto">
                                        Para continuar, é necessário autorizar a integração com o
                                        Melhor Envio. Clique no botão abaixo para ser redirecionado
                                        para a página de autorização.
                                    </div>
                                    <div className="botoes fonteTexto">
                                        <div className="cancelar" onClick={cancelar}>
                                            Cancelar
                                        </div>
                                        <a
                                            href={`${urlMelhorEnvio}oauth/authorize?client_id=${clientId}&redirect_uri=${urlRedirecionamento}&response_type=code&state=${nomeUsuario}-conecta-${clientId}-conecta-${secret}&scope=cart-read cart-write companies-read companies-write coupons-read coupons-write notifications-read orders-read products-read products-write purchases-read shipping-calculate shipping-cancel shipping-checkout shipping-companies shipping-generate shipping-preview shipping-print shipping-share shipping-tracking ecommerce-shipping transactions-read users-read users-write`}
                                            target="_blank"
                                        >
                                            <Button title="Autorizar"/>
                                        </a>
                                    </div>
                                </>
                            )}
                        </ModalContainer>
                    </Modal>
                </>
            )}
            {loading || !autenticado ? (
                <SkeletonBling/>
            ) : (
                <>
                    <div className="textoMelhorEnvio fonteTexto">
                        O Melhor Envio é uma solução integrada que facilita o cálculo de frete no seu catálogo.
                        Com ele, seus clientes veem o valor do frete na hora do pedido, de forma automática, e você pode
                        gerar etiquetas com preços mais acessíveis para Correios e transportadoras parceiras.
                        Use essa opção para agilizar os envios e transmitir mais confiança na hora da compra.
                    </div>
                    <div className="tituloConfigMelhorEnvio fonteSubtitulo">
                        Embalagem
                    </div>
                    <Grids>
                        <div className="containerInput">
                            <Input
                                maxLength={5}
                                showMaxLength={false}
                                name="Altura"
                                type="number"
                                value={configuracoes.frete.melhorEnvio.altura}
                                required={true}
                                placeholder={"0"}
                                label="Altura"
                                alignLabel="left"
                                onChange={(newValue) => {
                                    setConfiguracoes({
                                        ...configuracoes,
                                        frete: {
                                            ...configuracoes.frete,
                                            melhorEnvio: {
                                                ...configuracoes.frete.melhorEnvio,
                                                altura: newValue,
                                                // Preservar dados críticos do OAuth
                                                ...(configuracoes.frete.melhorEnvio.access_token && {
                                                    access_token: configuracoes.frete.melhorEnvio.access_token
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.refresh_token && {
                                                    refresh_token: configuracoes.frete.melhorEnvio.refresh_token
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.token_type && {
                                                    token_type: configuracoes.frete.melhorEnvio.token_type
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.expires_in && {
                                                    expires_in: configuracoes.frete.melhorEnvio.expires_in
                                                }),
                                            },
                                        },
                                    });
                                }}
                            />
                        </div>
                        <div className="containerInput">
                            <Input
                                maxLength={5}
                                type="number"
                                showMaxLength={false}
                                name="Largura"
                                label="Largura"
                                alignLabel="left"
                                value={configuracoes.frete.melhorEnvio.largura}
                                required={true}
                                placeholder={"0"}
                                onChange={(newValue) => {
                                    setConfiguracoes({
                                        ...configuracoes,
                                        frete: {
                                            ...configuracoes.frete,
                                            melhorEnvio: {
                                                ...configuracoes.frete.melhorEnvio,
                                                largura: newValue,
                                                // Preservar dados críticos do OAuth
                                                ...(configuracoes.frete.melhorEnvio.access_token && {
                                                    access_token: configuracoes.frete.melhorEnvio.access_token
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.refresh_token && {
                                                    refresh_token: configuracoes.frete.melhorEnvio.refresh_token
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.token_type && {
                                                    token_type: configuracoes.frete.melhorEnvio.token_type
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.expires_in && {
                                                    expires_in: configuracoes.frete.melhorEnvio.expires_in
                                                }),
                                            },
                                        },
                                    });
                                }}
                            />
                        </div>
                        <div className="containerInput ultimo">
                            <Input
                                maxLength={5}
                                showMaxLength={false}
                                required={true}
                                name="comprimento"
                                type="number"
                                label="Comprimento"
                                alignLabel="left"
                                value={configuracoes.frete.melhorEnvio.comprimento}
                                placeholder={"0"}
                                onChange={(newValue) => {
                                    setConfiguracoes({
                                        ...configuracoes,
                                        frete: {
                                            ...configuracoes.frete,
                                            melhorEnvio: {
                                                ...configuracoes.frete.melhorEnvio,
                                                comprimento: newValue,
                                                // Preservar dados críticos do OAuth
                                                ...(configuracoes.frete.melhorEnvio.access_token && {
                                                    access_token: configuracoes.frete.melhorEnvio.access_token
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.refresh_token && {
                                                    refresh_token: configuracoes.frete.melhorEnvio.refresh_token
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.token_type && {
                                                    token_type: configuracoes.frete.melhorEnvio.token_type
                                                }),
                                                ...(configuracoes.frete.melhorEnvio.expires_in && {
                                                    expires_in: configuracoes.frete.melhorEnvio.expires_in
                                                }),
                                            },
                                        },
                                    });
                                }}
                            />
                        </div>
                         {empresa?.tipo_pessoa === "J" && (
                     <div className="containerInput ultimo">
                        <Input
                            maxLength={11}
                            showMaxLength={false}
                            name="CNAE"
                            type="text"
                            value={configuracoes.frete.melhorEnvio.CNAE || ""}
                            required={true}
                            placeholder={"Ex: 00.00-0/00"}
                            label="CNAE"
                            alignLabel="left"
                            onChange={(newValue) => {
                                setConfiguracoes({
                                    ...configuracoes,
                                    frete: {
                                        ...configuracoes.frete,
                                        melhorEnvio: {
                                            ...configuracoes.frete.melhorEnvio,
                                            CNAE: newValue,
                                        },
                                    },
                                });
                            }}
                        />
                     </div>
                    )}
                    </Grids>
                </>
            )}
        </ContainerMelhorEnvio>
    );
};

export default MelhorEnvio;
